<div class="ui-g ui-fluid">
    <div class="ui-g-12" class="background">
      <div class="ui-g-12">
        <h2 class="title">Asistencia dental</h2>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-1 ui-md-1 ui-lg-1"></div>
      <div class=" ui-g-12 ui-md-12 ui-lg-10">
        <div class="ui-g-12 ui-md-4 ui-lg-3">
          <div class="card ui-g-12">
            <div class="center">
              <img src="../../assets/images/dental/silla.png" alt="" style="margin: 0 auto; width: 200px;">
            </div>
            <div class="ui-g-12">
              <p >Puede acceder a servicios dentales a tráves de una red exclusiva de clínicas</p>
            </div>
            <div class="ui-g-12">
              <div class="cardBlue3 ui-g-12"style="text-align: center;">
                  <a class="link" target="_blank" href="https://www.e-dentalsys.com/" >Visitar web</a>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-g-12 ui-md-8 ui-lg-9">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardBlue2 ui-g-12"  style="cursor: pointer;" (click)="showDialog()">
              <div class="center">
                <img class="margin" src="../../assets/images/dental/agendar_cita.png" alt="">
              </div>
              <div class="fondo">
                <h2 class="subTitleB">AGENDE SU CITA</h2>
              </div>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardBlue3 ui-g-12"  style="cursor: pointer;"  (click)="showDialog2()">
              <div class="center">
                <img class="margin" src="../../assets/images/dental/primer_cita.png" alt="">
              </div>
              <div class="fondo">
                <h2 class="subTitleW">PRIMERA CITA</h2>
              </div>
            </div>
          </div>
          
        </div>
        <div class="ui-g-12 ui-md-8 ui-lg-9">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardBlue3 ui-g-12"  style="cursor: pointer;"  (click)="showDialog3()">
              <div class="center">
                <img class="margin" src="../../assets/images/dental/autorizacion_servicio.png" alt="" >
              </div>
              <div class="fondo">
                <h2 class="subTitleW">AUTORIZACIÓN DE SERVICIOS</h2>
              </div>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardBlue2 ui-g-12"  style="cursor: pointer;"  (click)="showDialog4()">
              <div class="center">
                <img class="margin" src="../../assets/images/dental/conocer_experiencia.png" alt="" >
              </div>
              <div class="fondo">
                <h2 class="subTitleB" >CONOCER SU EXPERIENCIA</h2>
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-1 ui-md-6 ui-lg-6"></div>
            <div class="ui-g-12 ui-md-6 ui-lg-6 cardBlue3" (click)="navigate()" style="cursor: pointer;">
              <p class="subTitleW">¿A qué tiene acceso y cuánto debe pagar?</p>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g-1 ui-md-1 ui-lg-1"></div>
    </div>

    <p-dialog [(visible)]="appointment" [style]="{width: '60vw'}"  style="border: none;">
      <div class="ui-g-12 background">
        <p class="info">Asistencia dental</p>
        <p class="subTitleW2">Agende su cita</p>
      </div>
      <div class="ui-g-12 cardGray text-align">
        <div class="ui-g-12">
          <p>Comuníquese a:</p>
          <h3 class="margin">PSM ASSIST </h3>
        </div>
        <div class="ui-g-12">
              <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
              <div class="ui-g-12 ui-md-6 ui-lg-6 cardBlue"><p class="phone">+502 2383 6960</p></div>        
              <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
        </div>
        <div class="ui-g-12">
          <p>Para coordinar su primera cita. <br>
            Elija la clínica según su preferencia.</p>
          <h3 class="subTitle">Esta llamada es indispensable para activar el servicio</h3>
        </div>
      </div>
    </p-dialog>

    <p-dialog [(visible)]="firstDate" [style]="{width: '60vw'}"  style="border: none;">
      <div class="ui-g-12 background">
        <p class="info">Asistencia dental</p>
        <p class="subTitleW2">Primera cita</p>
      </div>
      <div class="cardGray ui-g-12">
        <div class="ui-g-12 p-grid">
          <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <p class="text-align">
              El odontólogo realizará la <b>evaluación inicial,</b>  se tomarán fotos y radiografías para su expediente electrónico.
            </p>
          </div>   
          <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
        </div>
      </div>
      
    </p-dialog>

    <p-dialog [(visible)]="services" [style]="{width: '60vw'}"  style="border: none;">
      <div class="ui-g-12 background">
        <p class="info">Asistencia dental</p>
        <p class="subTitleW2">Autorización de servicios</p>
      </div>
      <div class="cardGray ui-g-12">
        <div class="ui-g-12 p-grid">
          <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <p class="text-align">
              Nuestros odontólogos auditores <br> validarán su plan de tratamiento <br> en un <b> plazo de 24 a 48 horas.</b><br>
              Luego recibirá un email con la autorización <br> y detalle del tratamiento. Y listo podrá iniciar <br> la atención y coordinar las demás <br> citas directamente con la clínica.
            </p>
          </div>   
          <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
        </div>
      </div>
    </p-dialog>

    <p-dialog [(visible)]="knowExperience" [style]="{width: '50vw'}"  style="border: none;">
      <div class="ui-g-12 background">
        <p class="info">Asistencia dental</p>
        <p class="subTitleW2">Conocer su experiencia</p>
      </div>
      <div class="cardGray ui-g-12">
        <div class="ui-g-12 p-grid">
          <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <p class="text-align">
              Una vez realizada su atención nos comunicaremos <br> con usted para realizar una pequeña encuesta,<br> <b>validar el servicio que recibió</b> <br>
              y tomar en cuenta sus comentarios <br> para seguir mejorando su beneficio de asistencia dental.
            </p>
          </div>   
          <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
        </div>
      </div>
    </p-dialog>  
  </div>
  